/* eslint-disable import/order */
// eslint-disable-next-line import/no-cycle
import { types } from './actions';
import _ from 'lodash';

import { PICKLIST_OPTIONS } from '../AssetManagementForm/constants';
import { getActionTypes } from '../../../HelperMethods/UtilityFunctions';
import { GEOFENCE } from '../../../HelperMethods/enums';

// PREFERRED_LOCATION_PICKLIST_LOADING: 'PREFERRED_LOCATION_PICKLIST_LOADING',
// PREFERRED_LOCATION_PICKLIST_SUCCESSFULL: 'PREFERRED_LOCATION_PICKLIST_SUCCESSFULL',
// PREFERRED_LOCATION_PICKLIST_UNSUCCESFULL: 'PREFERRED_LOCATION_PICKLIST_UNSUCCESFULL',
const actionTypes = getActionTypes('Asset')([
  'LOAD_PREFERRED_LOCATION_TYPE_PICKLIST',
  'LOAD_ALL_ASSETS',
  'SET_LOADER',
  'SET_GRID_PARAM',
  'BULK_EDIT_ASSET',
  'SET_EXPORTING',
]);

export function loadRequiredAssets(data) {
  return { type: actionTypes.LOAD_ALL_ASSETS, data };
}

export function setBulkEditAssetList(data) {
  return { type: actionTypes.BULK_EDIT_ASSET, data };
}

export function setLoader(loader) {
  return { type: actionTypes.SET_LOADER, loader };
}

export function setGridParam(gridParam) {
  return { type: actionTypes.SET_GRID_PARAM, gridParam };
}

export function setIsExporting(isExporting) {
  return { type: actionTypes.SET_EXPORTING, isExporting };
}

export function setPreferredLocationTypePicklist(picklist) {
  return { type: actionTypes.LOAD_PREFERRED_LOCATION_TYPE_PICKLIST, picklist };
}

function geofenceCheck(geofence, state, asset) {
  // type is radial and radius is not empty or either one

  // type is polygon and radius is empty or polygon is not empty
  const { latitude, longitude } = asset;
  const radius = _.get(geofence, 'radius', '');
  const geofenceType = _.get(geofence, 'type');
  const polygonPoints = _.get(geofence, 'polygon', []);

  if (
    (_.isNumber(radius) && geofenceType === GEOFENCE.RADIAL) ||
    geofenceType === GEOFENCE.RADIAL ||
    _.isNumber(radius)
  ) {
    return {
      ...state,
      radialGeofence: { ...state.radialGeofence, radius, polygon: [{ latitude, longitude }] },
      polygonGeofence: { ...state.polygonGeofence },
    };
  }
  if (
    (geofenceType === GEOFENCE.POLYGON && _.isArray(polygonPoints) && !_.isEmpty(polygonPoints)) ||
    (_.isArray(polygonPoints) && !_.isEmpty(polygonPoints))
  ) {
    return {
      ...state,
      radialGeofence: { ...state.radialGeofence, radius: '', polygon: [{ latitude, longitude }] },
      polygonGeofence: { ...state.polygonGeofence, radius, polygon: polygonPoints },
    };
  }
  return state;
}

export default function assetReducer(
  state = {
    updateAssetsUploadInProgress: false,
    updatedAssetsAfterUpload: [],
    updateAssetsUploadError: false,
    assetlist: { assets: [], total: 0 },
    isLoading: false,
    searchStopId: '',
    reloadAssetState: false,
    editAsset: {},
    bulkAdd: {
      correctAsset: [],
      incorrectAsset: [],
      assetType: '',
    },
    assetStopList: [],
    radialGeofence: { type: 'radial', radius: '', polygon: [{ latitude: '', longitude: '' }] },
    polygonGeofence: {
      type: 'polygon',
      radius: '',
      polygon: [
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
      ],
    },
    dynamoResponse: [],
    assetEdit: { isLoading: false, item: {} },
    gridParam: { startRow: 0, endRow: 10 },
    [PICKLIST_OPTIONS.userListPicklist]: { isLoading: false, items: [] },
    [PICKLIST_OPTIONS.fieldOptions]: { isLoading: false, items: [] },
    [PICKLIST_OPTIONS.stopOptions]: { isLoading: false, items: [] },
    preferedLocationTypeList: {},
  },
  action
) {
  switch (action.type) {
    case types.RELOAD_ASSET_DETAILS: {
      const { reloadAssetState } = action;
      return {
        ...state,
        reloadAssetState,
      };
    }
    case types.STORING_ASSET_IN_LOCAL: {
      const { asset } = action;
      return {
        ...state,
        editAsset: asset,
      };
    }
    case types.DYNAMO_RESPONSE: {
      const { dynamoResponse } = action;
      return {
        ...state,
        dynamoResponse,
      };
    }
    case types.REMOVE_DYNAMO_RESPONSE: {
      return {
        ...state,
        dynamoResponse: [],
      };
    }
    case types.REMOVE_GEOFENCE_FROM_LOCAL: {
      return {
        ...state,
        radialGeofence: { type: 'radial', radius: '', polygon: [{ latitude: '', longitude: '' }] },
        polygonGeofence: {
          type: 'polygon',
          radius: '',
          polygon: [
            { latitude: '', longitude: '' },
            { latitude: '', longitude: '' },
            { latitude: '', longitude: '' },
          ],
        },
      };
    }

    case types.ASSET_GEOFENCE_UPDATE: {
      const { geofence } = action;
      const { type } = geofence;
      if (type === GEOFENCE.RADIAL) {
        return {
          ...state,
          radialGeofence: { ...geofence },
        };
      }
      if (type === GEOFENCE.POLYGON) {
        return {
          ...state,
          polygonGeofence: { ...geofence },
        };
      }

      return state;
    }

    case types.ASSET_GEOFENCE_TO_REDUX: {
      const { asset } = action;
      const geofence = _.get(asset, 'geofence', {});

      if (!_.isEmpty(geofence)) {
        return geofenceCheck(geofence, state, asset);
      }
      return state;
    }

    case types.REMOVING_ASSET_IN_LOCAL: {
      return {
        ...state,
        editAsset: {},
      };
    }
    case types.BULK_ASSET_LOAD_SUCCESFULL: {
      const { correctAsset, incorrectAsset, assetType } = action;

      return {
        ...state,
        bulkAdd: { correctAsset, incorrectAsset, assetType },
      };
    }
    case types.STOP_LIST: {
      const { assetStopList } = action;
      return {
        ...state,
        assetStopList,
      };
    }
    case types.SET_STOP_ID: {
      const { stopId } = action;
      return {
        ...state,
        searchStopId: stopId,
      };
    }

    case types.LOAD_FIELD_PICKLIST: {
      const { items } = action;
      return {
        ...state,
        fieldOptions: {
          isLoading: false,
          items,
        },
      };
    }
    case types.LOAD_FIELD_PICKLIST_FAIL: {
      return {
        ...state,
        fieldOptions: {
          isLoading: false,
          items: [],
        },
      };
    }
    case types.LOAD_USERS_FROM_FIELD: {
      return {
        ...state,
        userListPicklist: {
          isLoading: true,
          items: [],
        },
      };
    }
    case types.LOADING_USERS_FROM_FIELD_SUCCESSFULL: {
      const { users } = action;
      return {
        ...state,
        userListPicklist: {
          isLoading: false,
          items: users,
        },
      };
    }
    case types.LOADING_USERS_FROM_FIELD_UNSUCCESSFULL: {
      return {
        ...state,
        userListPicklist: {
          isLoading: false,
          items: [],
        },
      };
    }
    case types.LOAD_STOPS_FROM_FIELD: {
      return {
        ...state,
        stopOptions: {
          isLoading: true,
          items: [],
        },
      };
    }
    case types.LOADING_STOPS_FROM_FIELD_SUCCESSFULL: {
      const { stopsList } = action;
      return {
        ...state,
        stopOptions: {
          isLoading: false,
          items: stopsList,
        },
      };
    }
    case types.LOADING_STOPS_FROM_FIELD_UNSUCCESSFULL: {
      return {
        ...state,
        stopOptions: {
          isLoading: false,
          items: [],
        },
      };
    }

    case types.ASSET_LOADING: {
      return {
        ...state,
        assetEdit: {
          isLoading: true,
          item: {},
        },
      };
    }
    case types.ASSET_LOADED_SUCCESS: {
      const { asset } = action;
      return {
        ...state,
        assetEdit: {
          isLoading: false,
          item: asset,
        },
      };
    }
    case types.ASSET_LOAD_FAILED: {
      return {
        ...state,
        assetEdit: {
          isLoading: false,
          item: {},
        },
      };
    }

    case actionTypes.SET_LOADER: {
      return {
        ...state,
        isLoading: action.loader,
      };
    }
    case types.UPDATE_ASSETS_UPLOAD_IN_PROGRESS: {
      return {
        ...state,
        updateAssetsUploadInProgress: true,
        updatedAssetsAfterUpload: [],
        updateAssetsUploadError: false,
      };
    }
    case actionTypes.SET_EXPORTING: {
      return {
        ...state,
        isExporting: action.isExporting,
      };
    }
    case types.UPDATE_ASSETS_UPLOAD_SUCCESSFULL: {
      return {
        ...state,
        updateAssetsUploadInProgress: false,
        updatedAssetsAfterUpload: action.updatedAssetsAfterUpload,
        updateAssetsUploadError: false,
      };
    }
    case types.UPDATE_ASSETS_UPLOAD_FAILED: {
      return {
        ...state,
        updateAssetsUploadInProgress: false,
        updatedAssetsAfterUpload: [],
        updateAssetsUploadError: true,
      };
    }
    case types.UPDATE_ASSETS_UPLOAD_RESET: {
      return {
        ...state,
      };
    }
    case actionTypes.LOAD_ALL_ASSETS: {
      const { assets, total } = action.data;
      return {
        ...state,
        assetlist: { assets, total },
      };
    }
    case actionTypes.BULK_EDIT_ASSET: {
      return {
        ...state,
      };
    }
    case actionTypes.SET_GRID_PARAM: {
      return {
        ...state,
        gridParam: action.gridParam,
      };
    }
    case actionTypes.LOAD_PREFERRED_LOCATION_TYPE_PICKLIST: {
      return {
        ...state,
        preferedLocationTypeList: action.picklist,
      };
    }
    default:
      return state;
  }
}
